// extracted by mini-css-extract-plugin
export default {"button":"ApplyButton_button__WBqH4"};